"use client";
import {
  createElement,
  createHook,
  forwardRef
} from "./ILRXHV7V.js";

// src/role/role.tsx
var TagName = "div";
var elements = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
var useRole = createHook(
  function useRole2(props) {
    return props;
  }
);
var Role = forwardRef(
  // @ts-expect-error
  function Role2(props) {
    return createElement(TagName, props);
  }
);
Object.assign(
  Role,
  elements.reduce((acc, element) => {
    acc[element] = forwardRef(function Role3(props) {
      return createElement(element, props);
    });
    return acc;
  }, {})
);

export {
  useRole,
  Role
};
